// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"61ed26d8","890":"4176c6a5"}[chunkId] + ".chunk.js";
};